import type PicklistsService from '@efdigital/ll-addon-content/services/picklists';
import { service } from '@ember/service';
import Component from '@glimmer/component';

interface CoachProfilePicklistBadgesSignature {
  Args: {
    keys: string[];
    group: string;
    variant?: 'primary' | 'muted';
  };
  Element: HTMLDivElement;
}

export default class CoachProfilePicklistBadges extends Component<CoachProfilePicklistBadgesSignature> {
  @service declare readonly picklists: PicklistsService;

  get labels(): string[] {
    return (this.args.keys ?? []).map(
      (key) => this.picklists.lookup(this.args.group, key)?.title ?? key
    );
  }

  get badgeClass(): string {
    if (this.args.variant === 'primary') {
      return 'badge rounded-pill bg-primary-subtle text-primary-emphasis fw-semibold px-3 py-2';
    }
    return 'badge rounded-pill border bg-body-tertiary text-body-secondary fw-semibold px-3 py-2';
  }

  <template>
    {{#if @keys.length}}
      <div class="d-flex flex-wrap gap-2" ...attributes>
        {{#each this.labels as |label|}}
          <span class={{this.badgeClass}}>{{label}}</span>
        {{/each}}
      </div>
    {{/if}}
  </template>
}
